import { render } from "./Contact.vue?vue&type=template&id=fb307c94"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=fb307c94&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__